/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CourtDayResponse } from './CourtDayResponse';
import {
    CourtDayResponseFromJSON,
    CourtDayResponseFromJSONTyped,
    CourtDayResponseToJSON,
    CourtDayResponseToJSONTyped,
} from './CourtDayResponse';

/**
 * 
 * @export
 * @interface CourtResponse
 */
export interface CourtResponse {
    /**
     * 
     * @type {string}
     * @memberof CourtResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CourtResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CourtResponse
     */
    shortCode: string;
    /**
     * 
     * @type {string}
     * @memberof CourtResponse
     */
    fileNumberPrefix: string | null;
    /**
     * 
     * @type {string}
     * @memberof CourtResponse
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof CourtResponse
     */
    street: string | null;
    /**
     * 
     * @type {string}
     * @memberof CourtResponse
     */
    houseNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof CourtResponse
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof CourtResponse
     */
    country: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CourtResponse
     */
    districts: Array<number>;
    /**
     * 
     * @type {Array<CourtDayResponse>}
     * @memberof CourtResponse
     */
    courtDays: Array<CourtDayResponse>;
}

/**
 * Check if a given object implements the CourtResponse interface.
 */
export function instanceOfCourtResponse(value: object): value is CourtResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('shortCode' in value) || value['shortCode'] === undefined) return false;
    if (!('fileNumberPrefix' in value) || value['fileNumberPrefix'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('houseNumber' in value) || value['houseNumber'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('districts' in value) || value['districts'] === undefined) return false;
    if (!('courtDays' in value) || value['courtDays'] === undefined) return false;
    return true;
}

export function CourtResponseFromJSON(json: any): CourtResponse {
    return CourtResponseFromJSONTyped(json, false);
}

export function CourtResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourtResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'shortCode': json['shortCode'],
        'fileNumberPrefix': json['fileNumberPrefix'],
        'zipCode': json['zipCode'],
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'city': json['city'],
        'country': json['country'],
        'districts': json['districts'],
        'courtDays': ((json['courtDays'] as Array<any>).map(CourtDayResponseFromJSON)),
    };
}

export function CourtResponseToJSON(json: any): CourtResponse {
    return CourtResponseToJSONTyped(json, false);
}

export function CourtResponseToJSONTyped(value?: CourtResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'shortCode': value['shortCode'],
        'fileNumberPrefix': value['fileNumberPrefix'],
        'zipCode': value['zipCode'],
        'street': value['street'],
        'houseNumber': value['houseNumber'],
        'city': value['city'],
        'country': value['country'],
        'districts': value['districts'],
        'courtDays': ((value['courtDays'] as Array<any>).map(CourtDayResponseToJSON)),
    };
}

